<div class="schematic-tabs-wrapper">
  <div
    class="schematic-tab"
    *ngFor="let tab of tabs"
    [class.active]="tab.id === activeTab"
    (click)="selectTab(tab.id)"
  >
  <span class="schematic-tab-title">
    {{ tab.name }}
  </span>
    <span class="schematic-close-btn"
      (click)="closeTab(tab.id, $event)"
    >
      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.75 0.75L9 9M9 0.75L0.75 9" stroke="white" stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </span>
  </div>
</div>
